<div *ngIf="maintenanceOn" class="maintenance-screen">
  <img
    class="maintenance-logo"
    src="assets/images/main-cc-logo.svg"
    alt="Creator Catalyst"
  />
  <p class="maintenance-message">{{ maintenanceMessage }}</p>
</div>

<router-outlet *ngIf="!maintenanceOn"></router-outlet>
